import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  local: '',
  descricao: '',
  filial: [],
  disponibilizar: null,
  negativo: null,
  ativo: null,
};

export const LocalContext = createContext();

export const LocalProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [local, setLocal] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getLocal = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: local?.filter,
        page: local?.page,
        size: local?.size,
        order: local?.order,
        ...payload,
      });
      setLocal((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <LocalContext.Provider
      value={{
        getLoading,
        local,
        getLocal,
      }}
    >
      {children}
    </LocalContext.Provider>
  );
};
